import { Navigate, useParams } from 'react-router';

const ReferralPage = () => {
  const params = useParams();

  return <Navigate to={`/?referral=${params.referral}`} />;
};

export default ReferralPage;
